import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import routes from './router/index'
import Bridge from './js/jsBridge.js'
import global from './js/ai.js'
import { Popover,Progress,Dialog, ActionSheet,Field,Checkbox, CheckboxGroup, CountDown  } from 'vant'
import vueAwesomeSwiper from "vue-awesome-swiper";
import VueLoadmore from 'vuejs-loadmore';
import anime from "animejs";
import VConsole from 'vconsole'

import common from './js/common.js'

import 'vant/lib/index.css'
import "./assets/css/index.css"

import VueI18n from 'vue-i18n';
import messages from './locales'; // 导入包含语言翻译的文件
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // 设置默认语言
  messages, // 语言翻译文件
  missing: (locale, key, vm, values) => {
    // You can return an empty string or any default value here
    return '';
  },
});

//整屏滚动
import 'fullpage.js/vendors/scrolloverflow';
import VueFullpage from 'vue-fullpage.js';
Vue.use(VueFullpage);

Vue.prototype.MErrorMessage = global;
Vue.prototype.$bridge = Bridge;
Vue.prototype.$anime = anime
Vue.prototype.$common = common
Vue.config.productionTip = false;
Vue.use(Router);
Vue.use(Popover);
Vue.use(Progress);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CountDown);
Vue.use(vueAwesomeSwiper);
Vue.use(VueLoadmore);
// Vue.use(request);

const vConsole = new VConsole()
window.$vConsole = vConsole

const router = new Router({
  base:'/dist/',
  linkActiveClass: 'active',
  routes,
});

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
});




// WEBPACK FOOTER //
// ./src/main.js